import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ec5c9eee&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ec5c9eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5c9eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec5c9eee')) {
      api.createRecord('ec5c9eee', component.options)
    } else {
      api.reload('ec5c9eee', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ec5c9eee&scoped=true&", function () {
      api.rerender('ec5c9eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b5iJXE26a1kS/JS/comp/GuestBox.vue"
export default component.exports